export const Palette = {
  'Brand/Blue': '#5BC4FF',
  'Brand/Brown': '#883100',
  'Brand/Cream': '#F6F2E9',
  'Brand/Dark Grey': '#68706D',
  'Brand/Green': '#38443F',
  'Brand/Light Grey': '#DDDAD2',
  'Brand/Maroon': '#7B043D',
  'Brand/Orange': '#FF7222',
  'Brand/Pink': '#FF3ED4',
  'Brand/Purple': '#480D93',
  'Brand/Yellow': '#E9E238',
  'Shades/Maroon 1': '#630331',
  'Shades/Maroon 2': '#4A0225',
  'Shades/Ivory Cream': '#F6F2E9',
  'Shades/Plum Wine': '#892955',
  'Global/Black': '#121212',
  'Global/White': '#FFFFFF',
  'Utility/Warning': '#A10000',
  'Utility/Error': '#A10000',
  'Utility/Success': '#207E57',
  'Admin/Background': '#FAF7F0',
  'Admin/Badge': '#F2E9ED',
  'Admin/Icon': '#781136',
  'Admin/Table Header': '#EEDEDA'
} as const

export type DSColor = keyof typeof Palette

export const Colors = Object.keys(Palette) as DSColor[]
export const PlayerColors = Colors.filter(
  (c) => !['Brand/Cream', 'Brand/Dark Grey', 'Brand/Green', 'Brand/Ivory Cream', 'Brand/Black'].includes(c)
)
export const ColorsForPlayers = Colors.filter((c) => ['Brand/Blue', 'Brand/Pink', 'Brand/Orange'].includes(c))
